import React from 'react';
import { Grid, Typography, Card, withStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { abbrevations } from '../constants';

const styles = (theme) => ({
	card: {
		border: 0,
		boxShadow: 'none',
		borderRadius: '2px',
		padding: '35px',
		display: 'flex',
		minHeight: '100%',
		cursor: 'pointer',
		transition: 'box-shadow ease .2s',
		alignItems: 'center',
		justifyContent: 'center',
		'&:hover': {
			boxShadow: '0 8px 5px -5px rgba(63, 81, 181, .2)',
		},
	},
	container: {
		'& a': {
			textDecoration: 'none',
		},
	},
	title: {
		fontWeight: 'bold',
		color: `${theme.palette.grey['100']}`,
	},
});

const PlatformCards = (props) => {
	const { dataField, aggregations, classes } = props;
	let cards = [];
	if (aggregations && aggregations[dataField] && aggregations[dataField].buckets) {
		cards = aggregations[dataField].buckets
			.map(({ key: itemKey, doc_count }) => ({
				title: itemKey,
				count: doc_count,
			}))
			.filter((_, index) => index < 6);
	}
	return (
		<Grid container spacing={8}>
			{cards.map((card) => (
				<Grid item md={2} sm={4} xs={6} key={card.title} className={classes.container}>
					<Link to={`/platform/?platform="${card.title}"`}>
						<Card
							className={classes.card}
							style={{
								...(abbrevations[card.title] || abbrevations.Wii).styles,
							}}
						>
							<Typography
								component="h2"
								className={classes.title}
								color="textPrimary"
								gutterBottom
							>
								{abbrevations[card.title]?.name || card.title}
							</Typography>
						</Card>
					</Link>
				</Grid>
			))}
		</Grid>
	);
};

export default withStyles(styles)(PlatformCards);
